import Vue from "vue";
import Vuex from "vuex";
import OOCUsers from "./ooc_user.store";
import Merchants from "./ooc.merchents.store";
import Menus from "./ooc.menus.store";
import Integrations from "./ooc.integrations.store";
import OOCOrders from "./ooc.orders.store";
Vue.use(Vuex);

/**
 * OOC Combine store
 * @example this.$store.state
 * @return {object}
 */
const OOCStore = {
  modules: {
    OOCUsers,
    Merchants,
    Menus,
    Integrations,
    OOCOrders,
  },
};
export default OOCStore;
